import React, { Component } from 'react';
import { Route } from 'react-router';
import { SecuredLayout } from './containers/Layout';
import { Customers } from './pages/Customers';
import { Customer } from './pages/Customer';
import { AggregatorConfig } from './pages/AggregatorConfig';
import { NotificationEventsReport } from './pages/NotificationEventsReport';
import { Provider } from 'mobx-react';
import { Login } from './pages/Login';
import { CreateAccount } from './pages/CreateAccount';
import { NotificationTypes } from './pages/NotificationTypes';
import { NotificationType } from './pages/NotificationType';
import { Organizations } from './pages/Organizations';
import { Organization } from './pages/Organization';
import { PolarisConfig } from './pages/PolarisConfig';
import rootStore from './stores/index';
import { Branches } from './pages/Branches';
import { CommunicationPreference } from './pages/CommunicationPreference';
import { Admin } from './pages/Admin';

export default class App extends Component {
  displayName = App.name;

  render() {
    return (
      <Provider {...rootStore.getStores()}>
        <div>
          <SecuredLayout>
            <Route exact path='/' component={Customers} />
            <Route exact path='/customer' component={Customers} />
            <Route exact path='/customer/:customerId' component={Customer} />
            <Route exact path='/customer/:customerId/polaris' component={PolarisConfig} />
            <Route exact path='/customer/:customerId/branches' component={Branches} />
            <Route exact path='/customer/:customerId/communication-preferences' component={CommunicationPreference} />
            <Route exact path='/customer/:customerId/config/:configId' component={AggregatorConfig} />
            <Route exact path='/reports' component={NotificationEventsReport} />
            <Route exact path='/create-account' component={CreateAccount} />
            <Route exact path='/notification-type' component={NotificationTypes} />
            <Route exact path='/notification-type/:notificationTypeId' component={NotificationType} />
            <Route exact path='/organization' component={Organizations} />
            <Route exact path='/organization/:organizationId' component={Organization} />
            <Route exact path='/admin' component={Admin} />
          </SecuredLayout>
          <Route exact path='/login' component={Login} />
        </div>
      </Provider>
    );
  }
}
